import "./CustomPagination.css";

const CustomPagination = ({
  totalCount,
  itemsPerPage,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const getPages = () => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 3) {
      return [1, 2, 3, "...", totalPages];
    }

    if (currentPage >= totalPages - 2) {
      return [1, "...", totalPages - 2, totalPages - 1, totalPages];
    }

    return [1, "...", currentPage, "...", totalPages];
  };

  const pages = getPages();

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  return (
    <div className="pg-wrapper">
      <div
        className="pg-nav"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <span
          style={{ fontSize: "12px", color: "black" }}
          class="material-symbols-rounded"
        >
          arrow_back
        </span>
      </div>

      {pages.map((page, index) => (
        <div
          key={`${page}-${index}`}
          className={`pg-btn ${page === currentPage ? "active" : ""} ${
            page === "..." ? "dots" : ""
          }`}
          onClick={() => handlePageChange(page)}
          disabled={page === "..."}
        >
          {page}
        </div>
      ))}

      <div
        className="pg-nav"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <span
          style={{ fontSize: "12px", color: "black" }}
          class="material-symbols-rounded"
        >
          arrow_forward
        </span>
      </div>
    </div>
  );
};

export default CustomPagination;
